module.exports = __webpack_public_path__ + "img/forte3.be59e251.jpeg";